module.exports = __webpack_public_path__ + "JM.png?f82c62615d0628acb698ef129f327734";